import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { IonSlides } from '@ionic/angular';

export interface ImagePickerTagVm {
  title: string;
  required: boolean;
  fulfilled: boolean;
  instruction?: string;
}

export interface ImagePickerPhotoVm<TMeta = any> {
  meta?: TMeta;
  title: string;
  fileName?: string;
  src: string;
}

@Component({
  selector: 'app-image-selector-ui',
  templateUrl: './image-selector-ui.component.html',
  styleUrls: ['./image-selector-ui.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageSelectorUiComponent<TPhotoMeta = any> {
  @ViewChild(IonSlides) slides?: IonSlides;

  @Input() viewOnlyMode = false;
  @Input() loading = true;

  @Input() sliderOptions: any;

  @Input() photos: ImagePickerPhotoVm<TPhotoMeta>[] = [];
  @Input() tags: ImagePickerTagVm[] = [];

  @Input() captureInProgress = false;
  @Input() isDisabled = false;

  @Input() showAddCard = true;
  @Input() addLabel = 'Add';

  @Input() enableEdit = true;
  @Input() enableRemove = true;

  @Output() captureRequested = new EventEmitter<{ tag?: ImagePickerTagVm }>();
  @Output() removeRequested = new EventEmitter<{ photo: ImagePickerPhotoVm<TPhotoMeta>; event: Event }>();
  @Output() editRequested = new EventEmitter<ImagePickerPhotoVm<TPhotoMeta>>();

  requestCapture(tag?: ImagePickerTagVm) {
    this.captureRequested.emit({ tag });
  }

  requestRemove(photo: ImagePickerPhotoVm<TPhotoMeta>, event: Event) {
    this.removeRequested.emit({ photo, event });
  }

  trackPhoto(index: number, photo: ImagePickerPhotoVm<TPhotoMeta>): string {
    return photo.fileName ?? `${index}`;
  }

  requestEdit(photo: ImagePickerPhotoVm<TPhotoMeta>) {
    this.editRequested.emit(photo);
  }

  async refreshSlides(): Promise<void> {
    if (!this.slides) return;
    await this.slides.update();
    this.slides.lockSwipes(false);
  }
}
